import { memo } from 'react';
import MuiIcon from '@mui/material/Icon';
import { useTheme } from '@emotion/react';
import { serviceTheme } from 'presentations/views/styles/color';

import dynamic from 'next/dynamic';
const Account = dynamic(() => import('./mdi/Account'));
const Creation = dynamic(() => import('./mdi/Creation'));
const Connection = dynamic(() => import('./mdi/Connection'));
const Monitor = dynamic(() => import('./mdi/Monitor'));
const Microsoft = dynamic(() => import('./mdi/Microsoft'));
const Google = dynamic(() => import('./mdi/Google'));
const Close = dynamic(() => import('./mdi/Close'));
const Poll = dynamic(() => import('./mdi/Poll'));
const CheckBold = dynamic(() => import('./mdi/CheckBold'));
const ContentCopy = dynamic(() => import('./mdi/ContentCopy'));
const ChevronDown = dynamic(() => import('./mdi/ChevronDown'));
const Cog = dynamic(() => import('./mdi/Cog'));
const Tools = dynamic(() => import('./mdi/Tools'));
const ChevronUp = dynamic(() => import('./mdi/ChevronUp'));
const Pencil = dynamic(() => import('./mdi/Pencil'));
const CursorDefaultClick = dynamic(() => import('./mdi/CursorDefaultClick'));
const Delete = dynamic(() => import('./mdi/Delete'));
const FormSelect = dynamic(() => import('./mdi/FormSelect'));
const FolderAccountOutline = dynamic(() =>
  import('./mdi/FolderAccountOutline'),
);
const FolderOutline = dynamic(() => import('./mdi/FolderOutline'));
const FolderCogOutline = dynamic(() => import('./mdi/FolderCogOutline'));
const FolderEditOutline = dynamic(() => import('./mdi/FolderEditOutline'));
const FormatListBulleted = dynamic(() => import('./mdi/FormatListBulleted'));
const CalendarMonth = dynamic(() => import('./mdi/CalendarMonth'));
const CalendarEdit = dynamic(() => import('./mdi/CalendarEdit'));
const CalendarClock = dynamic(() => import('./mdi/CalendarClock'));
const CalendarCursor = dynamic(() => import('./mdi/CalendarCursor'));
const CardAccountDetailsOutline = dynamic(() =>
  import('./mdi/CardAccountDetailsOutline'),
);
const ClipboardTextOutline = dynamic(() =>
  import('./mdi/ClipboardTextOutline'),
);
const CloudUploadOutline = dynamic(() => import('./mdi/CloudUploadOutline'));
const Apps = dynamic(() => import('./mdi/Apps'));
const AccountCog = dynamic(() => import('./mdi/AccountCog'));
const ChevronRight = dynamic(() => import('./mdi/ChevronRight'));
const Plus = dynamic(() => import('./mdi/Plus'));
const PlusCircle = dynamic(() => import('./mdi/PlusCircle'));
const PlusCircleOutline = dynamic(() => import('./mdi/PlusCircleOutline'));
const TrophyVariant = dynamic(() => import('./mdi/TrophyVariant'));
const Link = dynamic(() => import('./mdi/Link'));
const HelpCircle = dynamic(() => import('./mdi/HelpCircle'));
const Bell = dynamic(() => import('./mdi/Bell'));
const ChevronLeft = dynamic(() => import('./mdi/ChevronLeft'));
const Microphone = dynamic(() => import('./mdi/Microphone'));
const Stop = dynamic(() => import('./mdi/Stop'));
const Compass = dynamic(() => import('./mdi/Compass'));
const CloseCircleOutline = dynamic(() => import('./mdi/CloseCircleOutline'));
const ClockAlertOutline = dynamic(() => import('./mdi/ClockAlertOutline'));
const ClockOutline = dynamic(() => import('./mdi/ClockOutline'));
const Flag = dynamic(() => import('./mdi/Flag'));
const FlagVariant = dynamic(() => import('./mdi/FlagVariant'));
const FileDocumentOutline = dynamic(() => import('./mdi/FileDocumentOutline'));
const CheckboxMarkedOutline = dynamic(() =>
  import('./mdi/CheckboxMarkedOutline'),
);
const TimelineClockOutline = dynamic(() =>
  import('./mdi/TimelineClockOutline'),
);
const FilePdfOutline = dynamic(() => import('./mdi/FilePdfOutline'));
const ViewGrid = dynamic(() => import('./mdi/ViewGrid'));
const ViewGridPlus = dynamic(() => import('./mdi/ViewGridPlus'));
const ContentDuplicate = dynamic(() => import('./mdi/ContentDuplicate'));
const Video = dynamic(() => import('./mdi/Video'));
const VideoOutline = dynamic(() => import('./mdi/VideoOutline'));
const VideoOff = dynamic(() => import('./mdi/VideoOff'));
const Drag = dynamic(() => import('./mdi/Drag'));
const AccountGroup = dynamic(() => import('./mdi/AccountGroup'));
const FileImageOutline = dynamic(() => import('./mdi/FileImageOutline'));
const FilterVariant = dynamic(() => import('./mdi/FilterVariant'));
const Menu = dynamic(() => import('./mdi/Menu'));
const Home = dynamic(() => import('./mdi/Home'));
const Minus = dynamic(() => import('./mdi/Minus'));
const MinusCircle = dynamic(() => import('./mdi/Minus'));
const MinusBox = dynamic(() => import('./mdi/MinusBox'));
const DotsHorizontal = dynamic(() => import('./mdi/DotsHorizontal'));
const Login = dynamic(() => import('./mdi/Login'));
const ClockTimeNineOutline = dynamic(() =>
  import('./mdi/ClockTimeNineOutline'),
);
const Reload = dynamic(() => import('./mdi/Reload'));
const Replay = dynamic(() => import('./mdi/Replay'));
const AccountPlus = dynamic(() => import('./mdi/AccountPlus'));
const DebugStepOver = dynamic(() => import('./mdi/DebugStepOver'));
const ApplicationImport = dynamic(() => import('./mdi/ApplicationImport'));
const ApplicationCogOutline = dynamic(() =>
  import('./mdi/ApplicationCogOutline'),
);
const TextBoxOutline = dynamic(() => import('./mdi/TextBoxOutline'));
const TextBoxPlusOutline = dynamic(() => import('./mdi/TextBoxPlusOutline'));
const TextBoxCheckOutline = dynamic(() => import('./mdi/TextBoxCheckOutline'));
const MicrophoneOff = dynamic(() => import('./mdi/MicrophoneOff'));
const DotsVertical = dynamic(() => import('./mdi/DotsVertical'));
const CalendarText = dynamic(() => import('./mdi/CalendarText'));
const CalendarPlus = dynamic(() => import('./mdi/CalendarPlus'));
const CheckboxMultipleBlankOutline = dynamic(() =>
  import('./mdi/CheckboxMultipleBlankOutline'),
);
const FileDocumentEditOutline = dynamic(() =>
  import('./mdi/FileDocumentEditOutline'),
);
const Apple = dynamic(() => import('./mdi/Apple'));
const Android = dynamic(() => import('./mdi/Android'));
const LightbulbOnOutline = dynamic(() => import('./mdi/LightbulbOnOutline'));
const PlusThick = dynamic(() => import('./mdi/PlusThick'));
const Repeat = dynamic(() => import('./mdi/Repeat'));
const AlertCircleOutline = dynamic(() => import('./mdi/AlertCircleOutline'));
const ViewDashboard = dynamic(() => import('./mdi/ViewDashboard'));
const MessageProcessingOutline = dynamic(() =>
  import('./mdi/MessageProcessingOutline'),
);
const MessageBadgeOutline = dynamic(() => import('./mdi/MessageBadgeOutline'));
const MessageBadge = dynamic(() => import('./mdi/MessageBadge'));
const CommentTextOutline = dynamic(() => import('./mdi/CommentTextOutline'));
const Calendar = dynamic(() => import('./mdi/Calendar'));
const OpenInNew = dynamic(() => import('./mdi/OpenInNew'));
const MenuDown = dynamic(() => import('./mdi/MenuDown'));
const CalendarSync = dynamic(() => import('./mdi/CalendarSync'));
const Search = dynamic(() => import('./mdi/Search'));
const CalendarSearch = dynamic(() => import('./mdi/CalendarSearch'));
const Paperclip = dynamic(() => import('./mdi/Paperclip'));
const Pound = dynamic(() => import('./mdi/Pound'));
const Send = dynamic(() => import('./mdi/Send'));
const MapMarker = dynamic(() => import('./mdi/MapMarker'));
const Download = dynamic(() => import('./mdi/Download'));
const FileSearchOutline = dynamic(() => import('./mdi/FileSearchOutline'));
const OfficeBuildingOutline = dynamic(() =>
  import('./mdi/OfficeBuildingOutline'),
);
const EmailOutline = dynamic(() => import('./mdi/EmailOutline'));
const EmailSendOutline = dynamic(() => import('./mdi/EmailSendOutline'));
const EmailReceiveOutline = dynamic(() => import('./mdi/EmailReceiveOutline'));
const Slack = dynamic(() => import('./mdi/Slack'));
const EmailEditOutline = dynamic(() => import('./mdi/EmailEditOutline'));
const Phone = dynamic(() => import('./mdi/Phone'));
const Pin = dynamic(() => import('./mdi/Pin'));
const CheckCircle = dynamic(() => import('./mdi/CheckCircle'));
const CheckCircleOutline = dynamic(() => import('./mdi/CheckCircleOutline'));
const BookOpenBlankVariant = dynamic(() =>
  import('./mdi/BookOpenBlankVariant'),
);
const Palette = dynamic(() => import('./mdi/Palette'));
const TicketConfirmationOutline = dynamic(() =>
  import('./mdi/TicketConfirmationOutline'),
);
const Check = dynamic(() => import('./mdi/Check'));
const Circle = dynamic(() => import('./mdi/Circle'));
const AlertCircle = dynamic(() => import('./mdi/AlertCircle'));
const AccountCheck = dynamic(() => import('./mdi/AccountCheck'));
const ToggleSwitch = dynamic(() => import('./mdi/ToggleSwitch'));
const ToggleSwitchOff = dynamic(() => import('./mdi/ToggleSwitchOff'));
const Help = dynamic(() => import('./mdi/Help'));
const InformationOutline = dynamic(() => import('./mdi/InformationOutline'));
const Information = dynamic(() => import('./mdi/Information'));
const CodeTags = dynamic(() => import('./mdi/CodeTags'));
const Tag = dynamic(() => import('./mdi/Tag'));
const TagOutline = dynamic(() => import('./mdi/TagOutline'));
const Update = dynamic(() => import('./mdi/Update'));
const CloseCircle = dynamic(() => import('./mdi/CloseCircle'));
const Star = dynamic(() => import('./mdi/Star'));
const StarHalfFull = dynamic(() => import('./mdi/StarHalfFull'));
const StarCheck = dynamic(() => import('./mdi/StarCheck'));
const CalendarCheck = dynamic(() => import('./mdi/CalendarCheck'));
const Twitter = dynamic(() => import('./mdi/Twitter'));
const Facebook = dynamic(() => import('./mdi/Facebook'));
const Instagram = dynamic(() => import('./mdi/Instagram'));
const Youtube = dynamic(() => import('./mdi/Youtube'));
const LinkedIn = dynamic(() => import('./mdi/LinkedIn'));
const Web = dynamic(() => import('./mdi/Web'));
const CalendarLock = dynamic(() => import('./mdi/CalendarLock'));
const AccountLock = dynamic(() => import('./mdi/AccountLock'));
const Lock = dynamic(() => import('./mdi/Lock'));
const Payment = dynamic(() => import('./mdi/Payment'));
const StorefrontOutline = dynamic(() => import('./mdi/StorefrontOutline'));
const AccountEdit = dynamic(() => import('./mdi/AccountEdit'));
const Vanish = dynamic(() => import('./mdi/Vanish'));
const DesktopMacDashboard = dynamic(() => import('./mdi/DesktopMacDashboard'));
const ArrowLeft = dynamic(() => import('./mdi/ArrowLeft'));
const ArrowRight = dynamic(() => import('./mdi/ArrowRight'));
const NewBox = dynamic(() => import('./mdi/NewBox'));
const InboxArrowDown = dynamic(() => import('./mdi/InboxArrowDown'));
const ArrowDown = dynamic(() => import('./mdi/ArrowDown'));
const ShareVariantOutline = dynamic(() => import('./mdi/ShareVariantOutline'));
const NoteTextOutline = dynamic(() => import('./mdi/NoteTextOutline'));
const Launch = dynamic(() => import('./mdi/Launch'));
const ExportVariant = dynamic(() => import('./mdi/ExportVariant'));
const Earth = dynamic(() => import('./mdi/Earth'));
const FileDownloadOutline = dynamic(() => import('./mdi/FileDownloadOutline'));
const FileUploadOutline = dynamic(() => import('./mdi/FileUploadOutline'));
const TimerOutline = dynamic(() => import('./mdi/TimerOutline'));
const ViewWeekOutline = dynamic(() => import('./mdi/ViewWeekOutline'));
const ViewDayOutline = dynamic(() => import('./mdi/ViewDayOutline'));
const CalendarExpandHorizontal = dynamic(() =>
  import('./mdi/CalendarExpandHorizontal'),
);
const ChartBarStacked = dynamic(() => import('./mdi/ChartBarStacked'));
const ViewAgenda = dynamic(() => import('./mdi/ViewAgenda'));
const FlagTriangle = dynamic(() => import('./mdi/FlagTriangle'));
const Label = dynamic(() => import('./mdi/Label'));
const CircleSlice2 = dynamic(() => import('./mdi/CircleSlice2'));
const CircleSlice4 = dynamic(() => import('./mdi/CircleSlice4'));
const CircleSlice8 = dynamic(() => import('./mdi/CircleSlice8'));
const BlockHelper = dynamic(() => import('./mdi/BlockHelper'));
const ArrowDownThin = dynamic(() => import('./mdi/ArrowDownThin'));
const CalendarImport = dynamic(() => import('./mdi/CalendarImport'));
const CalendarExport = dynamic(() => import('./mdi/CalendarExport'));
const ListBoxOutline = dynamic(() => import('./mdi/ListBoxOutline'));
const TagCheckOutline = dynamic(() => import('./mdi/TagCheckOutline'));
const ChartBar = dynamic(() => import('./mdi/ChartBar'));
const Console = dynamic(() => import('./mdi/Console'));
const TransitSkip = dynamic(() => import('./mdi/TransitSkip'));

interface Props {
  name: string;
  className?: string;
  style?: any;
  color?: 'inherit' | 'primary' | 'secondary' | 'action' | 'error' | 'disabled';
  fontSize?: 'inherit' | 'medium' | 'small' | 'large';
  size?: number | string;
}

const Component = memo((props: Props) => {
  const theme = useTheme();
  const MdiComponent = getMdiSvg(props.name);
  if (MdiComponent) {
    return (
      <MdiComponent
        name={props.name}
        color={
          props.color
            ? props.color === 'inherit'
              ? 'inherit'
              : serviceTheme(props.color, { theme })
            : undefined
        }
        className={props.className}
        size={props.size || 1}
        style={props.style}
      />
    );
  }
  return (
    <MuiIcon
      className={props.className}
      color={props.color}
      fontSize={props.fontSize}
      style={props.style}
    >
      {props.name}
    </MuiIcon>
  );
});

function getMdiSvg(name: string) {
  switch (name) {
    case 'account':
      return Account;
    case 'clear':
      return Close;
    case 'close':
      return Close;
    case 'connection':
      return Connection;
    case 'monitor':
      return Monitor;
    case 'microsoft':
      return Microsoft;
    case 'google':
      return Google;
    case 'check':
      return CheckBold;
    case 'file_copy_outlined':
      return ContentCopy;
    case 'vanish':
      return Vanish;
    case 'desktop-mac-dashboard':
    case 'monitor':
      return DesktopMacDashboard;
    case 'file-pdf-outline':
      return FilePdfOutline;
    case 'chevron-down':
    case 'expand_more':
      return ChevronDown;
    case 'chevron-up':
    case 'expand_less':
      return ChevronUp;
    case 'settings':
      return Cog;
    case 'tools':
      return Tools;
    case 'edit':
      return Pencil;
    case 'delete':
      return Delete;
    case 'drag':
      return Drag;
    case 'folder_shared_outlined':
      return FolderAccountOutline;
    case 'folder-outline':
      return FolderOutline;
    case 'folder-cog-outline':
      return FolderCogOutline;
    case 'folder-edit-outline':
      return FolderEditOutline;
    case 'format-list-bulleted':
      return FormatListBulleted;
    case 'card-account-details-outline':
      return CardAccountDetailsOutline;
    case 'calendar-month':
      return CalendarMonth;
    case 'calendar-edit':
      return CalendarEdit;
    case 'calendar-clock':
      return CalendarClock;
    case 'calendar-cursor':
      return CalendarCursor;
    case 'apps':
      return Apps;
    case 'account-cog':
      return AccountCog;
    case 'chevron-right':
      return ChevronRight;
    case 'chevron-left':
      return ChevronLeft;
    case 'plus':
      return Plus;
    case 'link':
      return Link;
    case 'help':
      return HelpCircle;
    case 'help-solid':
      return Help;
    case 'notifications':
      return Bell;
    case 'microphone':
      return Microphone;
    case 'microphone-off':
      return MicrophoneOff;
    case 'stop':
      return Stop;
    case 'explore':
      return Compass;
    case 'highlight_off':
      return CloseCircleOutline;
    case 'close-circle-outline':
      return CloseCircleOutline;
    case 'clock-alert-outline':
      return ClockAlertOutline;
    case 'schedule':
      return ClockOutline;
    case 'poll':
      return Poll;
    case 'flag':
      return Flag;
    case 'flag-variant':
      return FlagVariant;
    case 'file-document-outline':
      return FileDocumentOutline;
    case 'file-image-outline':
      return FileImageOutline;
    case 'clipboard-text-outline':
      return ClipboardTextOutline;
    case 'cloud-upload-outline':
      return CloudUploadOutline;
    case 'calendar-plus':
      return CalendarPlus;
    case 'checkbox-marked-outline':
      return CheckboxMarkedOutline;
    case 'trophy-variant':
      return TrophyVariant;
    case 'timeline-clock-outline':
      return TimelineClockOutline;
    case 'view-grid':
      return ViewGrid;
    case 'view-grid-plus':
      return ViewGridPlus;
    case 'content-duplicate':
      return ContentDuplicate;
    case 'video':
      return Video;
    case 'video-outline':
      return VideoOutline;
    case 'video-off':
      return VideoOff;
    case 'account-group':
      return AccountGroup;
    case 'earth':
      return Earth;
    case 'filter-variant':
      return FilterVariant;
    case 'menu':
      return Menu;
    case 'home':
      return Home;
    case 'minus':
      return Minus;
    case 'minus-circle':
      return MinusCircle;
    case 'minus-box':
      return MinusBox;
    case 'dots-horizontal':
      return DotsHorizontal;
    case 'dots-vertical':
      return DotsVertical;
    case 'login':
      return Login;
    case 'access_time':
    case 'clock-time-nine-outline':
      return ClockTimeNineOutline;
    case 'reload':
      return Reload;
    case 'replay':
      return Replay;
    case 'account-plus':
      return AccountPlus;
    case 'debug-step-over':
      return DebugStepOver;
    case 'application-import':
      return ApplicationImport;
    case 'application-cog-outline':
      return ApplicationCogOutline;
    case 'text-box-outline':
      return TextBoxOutline;
    case 'text-box-plus-outline':
      return TextBoxPlusOutline;
    case 'text-box-check-outline':
      return TextBoxCheckOutline;
    case 'calendar-text':
      return CalendarText;
    case 'checkbox-multiple-blank-outline':
      return CheckboxMultipleBlankOutline;
    case 'file-document-edit-outline':
      return FileDocumentEditOutline;
    case 'logo-apple':
      return Apple;
    case 'logo-android':
      return Android;
    case 'bulb-on-outline':
      return LightbulbOnOutline;
    case 'note-text-outline':
      return NoteTextOutline;
    case 'plus-thick':
      return PlusThick;
    case 'plus-circle':
      return PlusCircle;
    case 'plus-circle-outline':
      return PlusCircleOutline;
    case 'alert-circle-outline':
      return AlertCircleOutline;
    case 'view-dashboard':
      return ViewDashboard;
    case 'message-processing-outline':
      return MessageProcessingOutline;
    case 'message-badge':
      return MessageBadge;
    case 'message-badge-outline':
      return MessageBadgeOutline;
    case 'comment-text-outline':
      return CommentTextOutline;
    case 'calendar':
      return Calendar;
    case 'open-in-new':
      return OpenInNew;
    case 'menu-down':
      return MenuDown;
    case 'calendar-sync':
      return CalendarSync;
    case 'calendar-search':
      return CalendarSearch;
    case 'search':
      return Search;
    case 'paper-clip':
      return Paperclip;
    case 'cursor-default-click':
      return CursorDefaultClick;
    case 'map-marker':
      return MapMarker;
    case 'download':
      return Download;
    case 'file-search-outline':
      return FileSearchOutline;
    case 'office-building-outline':
      return OfficeBuildingOutline;
    case 'email-outline':
      return EmailOutline;
    case 'send':
      return Send;
    case 'email-arrow-right-outline':
    case 'email-send-outline':
      return EmailSendOutline;
    case 'email-arrow-left-outline':
    case 'email-receive-outline':
      return EmailReceiveOutline;
    case 'slack':
      return Slack;
    case 'email-edit-outline':
      return EmailEditOutline;
    case 'phone':
      return Phone;
    case 'pin':
      return Pin;
    case 'form-select':
      return FormSelect;
    case 'check-circle':
      return CheckCircle;
    case 'check-circle-outline':
      return CheckCircleOutline;
    case 'contact':
      return BookOpenBlankVariant;
    case 'palette':
      return Palette;
    case 'toggle-switch':
      return ToggleSwitch;
    case 'toggle-switch-off':
      return ToggleSwitchOff;
    case 'ticket-confirmation-outline':
      return TicketConfirmationOutline;
    case 'check-solid':
      return Check;
    case 'circle':
      return Circle;
    case 'alert-circle':
      return AlertCircle;
    case 'account-check':
      return AccountCheck;
    case 'code-tags':
      return CodeTags;
    case 'tag':
      return Tag;
    case 'tag-outline':
      return TagOutline;
    case 'hashtag':
      return Pound;
    case 'update':
      return Update;
    case 'close-circle':
      return CloseCircle;
    case 'info':
      return Information;
    case 'information-outline':
      return InformationOutline;
    case 'star-check':
      return StarCheck;
    case 'star':
      return Star;
    case 'star-half-full':
      return StarHalfFull;
    case 'calendar-check':
      return CalendarCheck;
    case 'twitter':
      return Twitter;
    case 'facebook':
      return Facebook;
    case 'instagram':
      return Instagram;
    case 'youtube':
      return Youtube;
    case 'linkedin':
      return LinkedIn;
    case 'web':
      return Web;
    case 'calendar-lock':
      return CalendarLock;
    case 'account-lock':
      return AccountLock;
    case 'lock':
      return Lock;
    case 'payment':
      return Payment;
    case 'storefront-outline':
      return StorefrontOutline;
    case 'account-edit':
      return AccountEdit;
    case 'arrow-left':
      return ArrowLeft;
    case 'arrow-right':
      return ArrowRight;
    case 'new-box':
      return NewBox;
    case 'inbox-arrow-down':
      return InboxArrowDown;
    case 'arrow-down':
      return ArrowDown;
    case 'arrow-down-thin':
      return ArrowDownThin;
    case 'share-variant-outline':
      return ShareVariantOutline;
    case 'launch':
      return Launch;
    case 'export-variant':
      return ExportVariant;
    case 'file-download-outline':
      return FileDownloadOutline;
    case 'file-upload-outline':
      return FileUploadOutline;
    case 'timer-outline':
      return TimerOutline;
    case 'view-week-outline':
      return ViewWeekOutline;
    case 'view-day-outline':
      return ViewDayOutline;
    case 'calendar-expand-horizontal':
      return CalendarExpandHorizontal;
    case 'chart-bar-stacked':
      return ChartBarStacked;
    case 'chart-bar':
      return ChartBar;
    case 'view-agenda':
      return ViewAgenda;
    case 'flag-triangle':
      return FlagTriangle;
    case 'label':
      return Label;
    case 'repeat':
      return Repeat;
    case 'circle-slice-2':
      return CircleSlice2;
    case 'circle-slice-4':
      return CircleSlice4;
    case 'circle-slice-8':
      return CircleSlice8;
    case 'block-helper':
      return BlockHelper;
    case 'calendar-import':
      return CalendarImport;
    case 'calendar-export':
      return CalendarExport;
    case 'add':
      return Plus;
    case 'list_alt_rounded':
    case 'list-box-outline':
      return ListBoxOutline;
    case 'creation':
      return Creation;
    case 'console':
      return Console;
    case 'tag-check-outline':
      return TagCheckOutline;
    case 'transit-skip':
      return TransitSkip;
    default:
      console.debug('unknown icon name.', name);
      break;
  }
  return null;
}
export default Component;
